import type { Background } from '@/api/types/background'
import type { BackgroundVisual } from './types/background-visual'

/**
 * A "formula color" background has no image URL at all — only a `fillColor` swatch description.
 * Mirrors legacy's own branch (`itemsource == null` in
 * `page-editor/src/client/libraries/odctrl.js` ~line 15428): prefer the image URL when present,
 * otherwise fall back to the solid-color swatch. `fillColor.hexValue` has no leading "#".
 */
export function resolveBackgroundVisual(background: Background): BackgroundVisual {
  const url = background.urlScr || background.urlPri

  if (url) return { kind: 'image', url }

  const hex = background.fillColor?.hexValue

  if (hex) return { kind: 'color', hex: hex.startsWith('#') ? hex : `#${hex}` }

  return { kind: 'none' }
}
